import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import {
  StyledChatListItem,
  StyledChatListItemContent,
} from "../../index.styled";
import { StyledChatUserAvatarView } from "../../userInfo.styled";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, Flex, Tooltip } from "antd";
import dayjs from "dayjs";
import { truncate } from "lodash";

type ChatItemProps = {
  item: any & { contactName: string };
};

const ChatItem: React.FC<ChatItemProps> = (props) => {
  const { item } = props;
  const [lastMessageContent, setLastMessageContent] = useState(
    item.lastMessage?.content || "",
  );
  const { whatsappNumber, chatId } = useParams();

  useEffect(() => {
    setLastMessageContent(item.lastMessage?.content || "");
  }, [item]);

  const navigate = useNavigate();

  const setSelectedUser = useCallback((item) => {
    navigate(`/whatsapp-account/${whatsappNumber}/chat/${item.id}`);
  }, []);

  const renderLastMessage = () => {
    // if (item.lastMessage?.type === IMessageTypes.CHAT) {
    //   return item.lastMessage?.content;
    // }
    // if (item.lastMessage?.type === IMessageTypes.IMAGE) {
    //   return "Image";
    // }
    // if (item.lastMessage?.type === IMessageTypes.VIDEO) {
    //   return "Video";
    // }
    // if (item.lastMessage?.type === IMessageTypes.AUDIO) {
    //   return "Audio";
    // }
    // if (item.lastMessage?.type === IMessageTypes.DOCUMENT) {
    //   return "Document";
    // }
    // if (item.lastMessage?.type === IMessageTypes.PTT) {
    //   return "Voice message";
    // }
    // if (item.lastMessage?.type === IMessageTypes.STICKER) {
    //   return "Sticker";
    // }
    return item.lastMessage?.content;
  };

  return (
    <StyledChatListItem
      className={clsx("item-hover", {
        active: chatId === item.id,
      })}
      onClick={() => setSelectedUser(item)}
    >
      <StyledChatUserAvatarView>
        <Avatar
          style={{ fontSize: "1.5rem", width: "3rem", height: "3rem" }}
          // icon={<UserOutlined />}
        />
      </StyledChatUserAvatarView>
      <StyledChatListItemContent>
        <Flex style={{ justifyContent: "space-between", alignItems: "center" }}>
          <h2>
            <Tooltip title={item?.contactName ?? item?.contact}>
              {truncate(item?.contactName ?? item?.contact, { length: 16 })}
            </Tooltip>
          </h2>
          <span>
            {dayjs.unix(Number(item?.lastMessage?.timeStamp)).fromNow()}
          </span>
        </Flex>
        <h3>
          {
            <Tooltip
              title={
                item?.lead?.nickname ||
                [(item?.lead?.firstName, item?.lead?.lastName)].join(" ")
              }
            >
              {item?.lead?.nickname ||
                [item?.lead?.firstName, item?.lead?.lastName].join(" ")}
            </Tooltip>
          }
        </h3>
        <p className="text-truncate mb-0">{renderLastMessage()}</p>
      </StyledChatListItemContent>
    </StyledChatListItem>
  );
};

export default ChatItem;
